"use client";

import { c as _c } from "react/compiler-runtime";
import { Switch } from "@/components/ui/switch";
import type { ConnectorType } from "@/stores/connectorsStore";
import { PixelLoader } from "@/components/ui/pixel-loader";
import Link from "next/link";
import { ConnectorLogo } from "./ConnectorLogo";
import { connectorTypeToIntegrationSlug } from "@/lib/connectors/slug";
interface ConnectorCardProps {
  connectorType: ConnectorType;
  onAdd: (type: string) => void;
  isConnecting?: boolean;
  isConnected?: boolean;
  onManage?: () => void;
}
export function ConnectorCard(t0) {
  const $ = _c(31);
  const {
    connectorType,
    onAdd,
    isConnecting,
    isConnected,
    onManage
  } = t0;
  let t1;
  if ($[0] !== connectorType.type || $[1] !== isConnected || $[2] !== onAdd || $[3] !== onManage) {
    t1 = () => {
      if (isConnected && onManage) {
        onManage();
      } else {
        onAdd(connectorType.type);
      }
    };
    $[0] = connectorType.type;
    $[1] = isConnected;
    $[2] = onAdd;
    $[3] = onManage;
    $[4] = t1;
  } else {
    t1 = $[4];
  }
  const handleActivate = t1;
  const integrationHref = `/integrations/app/${connectorTypeToIntegrationSlug(connectorType.type)}`;
  let t2;
  if ($[5] !== connectorType.logoUrl || $[6] !== connectorType.name || $[7] !== connectorType.type) {
    t2 = <div className="ds-logo-wrapper"><ConnectorLogo type={connectorType.type} name={connectorType.name} logoUrl={connectorType.logoUrl} size="base" /></div>;
    $[5] = connectorType.logoUrl;
    $[6] = connectorType.name;
    $[7] = connectorType.type;
    $[8] = t2;
  } else {
    t2 = $[8];
  }
  let t3;
  if ($[9] !== connectorType.name) {
    t3 = <span className="text-ds-text-secondary min-w-0 flex-1 truncate font-mono text-sm font-medium uppercase">{connectorType.name}</span>;
    $[9] = connectorType.name;
    $[10] = t3;
  } else {
    t3 = $[10];
  }
  let t4;
  if ($[11] !== t2 || $[12] !== t3) {
    t4 = <div className="flex min-w-0 flex-1 items-center gap-3">{t2}{t3}</div>;
    $[11] = t2;
    $[12] = t3;
    $[13] = t4;
  } else {
    t4 = $[13];
  }
  let t5;
  if ($[14] !== handleActivate || $[15] !== isConnected || $[16] !== isConnecting) {
    t5 = isConnecting ? <PixelLoader size="sm" color="blue" className="mt-0.5" /> : <Switch checked={isConnected} onCheckedChange={handleActivate} size="sm" />;
    $[14] = handleActivate;
    $[15] = isConnected;
    $[16] = isConnecting;
    $[17] = t5;
  } else {
    t5 = $[17];
  }
  let t6;
  if ($[18] !== t4 || $[19] !== t5) {
    t6 = <div className="flex items-start gap-2">{t4}{t5}</div>;
    $[18] = t4;
    $[19] = t5;
    $[20] = t6;
  } else {
    t6 = $[20];
  }
  const t7 = connectorType.description || "No description available";
  let t8;
  if ($[21] !== t7) {
    t8 = <p className="text-ds-text-muted line-clamp-2 min-h-[2lh] text-sm leading-5">{t7}</p>;
    $[21] = t7;
    $[22] = t8;
  } else {
    t8 = $[22];
  }
  let t9;
  if ($[23] !== t6 || $[24] !== t8) {
    t9 = <div className="flex flex-col gap-2 px-3.5 pb-5 pt-3.5">{t6}{t8}</div>;
    $[23] = t6;
    $[24] = t8;
    $[25] = t9;
  } else {
    t9 = $[25];
  }
  let t10;
  if ($[26] !== integrationHref) {
    t10 = <div className="border-ds-border mt-auto border-t px-5 py-4"><Link href={integrationHref} className="text-ds-brand-600 hover:text-ds-brand-700 ml-auto block text-sm font-medium transition-colors">View integration</Link></div>;
    $[26] = integrationHref;
    $[27] = t10;
  } else {
    t10 = $[27];
  }
  let t11;
  if ($[28] !== t10 || $[29] !== t9) {
    t11 = <div className="ds-shell flex flex-col overflow-hidden">{t9}{t10}</div>;
    $[28] = t10;
    $[29] = t9;
    $[30] = t11;
  } else {
    t11 = $[30];
  }
  return t11;
}